import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'people-behind';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { PeopleBehind: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
